import { render, staticRenderFns } from "./Positive.vue?vue&type=template&id=e3bfb71c&scoped=true"
import script from "./Positive.vue?vue&type=script&lang=js"
export * from "./Positive.vue?vue&type=script&lang=js"
import style0 from "./Positive.vue?vue&type=style&index=0&id=e3bfb71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bfb71c",
  null
  
)

export default component.exports